// src/App.js
import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toolbar, Box } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';

import Nav from './components/Nav';
import GuardedRoute from './components/GuardedRoute';
import { routes } from './routesConfig';

// --- IMPORTANTE: Importe o AuthProvider aqui ---
import { AuthProvider } from './AuthContext';

// Componente interno para acessar o hook useKeycloak (que só funciona dentro do Provider)
function AppContent() {
    const { keycloak } = useKeycloak();

    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100vh',
                bgcolor: 'background.default',
                overflowX: 'hidden',
            }}
        >
            {keycloak.authenticated && <Nav />}

            <Box component="main" sx={{ flexGrow: 1, minWidth: 0, transition: '0.2s' }}>
                {keycloak.authenticated && <Toolbar />}
                <Suspense fallback={null}>
                    <Routes>
                        {routes.map(
                            ({
                                path,
                                element: Component,
                                private: isPrivate,
                                roles,
                            }) =>
                                isPrivate ? (
                                    <Route
                                        key={path}
                                        path={path}
                                        element={
                                            <GuardedRoute
                                                Component={Component}
                                                roles={roles}
                                            />
                                        }
                                    />
                                ) : (
                                    <Route
                                        key={path}
                                        path={path}
                                        element={<Component />}
                                    />
                                )
                        )}
                    </Routes>
                </Suspense>
            </Box>
        </Box>
    );
}

// O App principal agora exporta apenas a estrutura dos Providers
export default function App() {
    // Nota: O ReactKeycloakProvider já deve estar no index.js ou acima deste App.
    // Se o ReactKeycloakProvider estiver no index.js, basta colocar o AuthProvider aqui.

    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}
